<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	name: 'Product Name',
	imageURL: '/og.jpg',
}
const schema = defineSchema({
	name: $.text('Product Name'),
	imageURL: $.upload('Product Image'),
})
export const StoreHeader = defineBlock({ thumbnail: '/block-thumbs/StoreHeader.svg', category: 'Hero', order: 380, name: 'StoreHeader', label: 'Store Header', icon: 'storefront', schema, defaults })
</script>
<script setup lang="ts">


import BlockProductHero from '@/components/blocks/BlockProductHero.vue'

// Kept for CMS backward-compatibility (existing pages reference `StoreHeader`).
// Rendering is delegated to the generic `BlockProductHero`.



const props = defineProps<{
	name?: string
	imageURL?: string
}>()
</script>

<template>
	<BlockProductHero v-bind="{ name: props.name, imageURL: props.imageURL }" />
</template>
